import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/components/NotFound";
import { parseSeriesParam } from "@/lib/showSlug";
import {
  CatalogPage,
  filterByCategory,
  useCatalogIndex,
} from "@/modules/Catalog";

// `/categories/{slug}-{id}`, the show param's shape: a param without an id is
// a 404 before anything is queried (like the actor page); an id the index
// doesn't hold, after.
export const Route = createFileRoute("/_default/categories/$category")({
  loader: ({ params }) => {
    const genreId = parseSeriesParam(params.category);
    if (!genreId) throw notFound();
    return { genreId };
  },
  notFoundComponent: NotFound,
  component: RouteComponent,
});

function RouteComponent() {
  const { genreId } = Route.useLoaderData();
  const { genres, shows, loading, error } = useCatalogIndex();
  const genre = genres.find((entry) => entry.id === genreId);

  if (!loading && !error && !genre) return <NotFound />;

  return (
    <CatalogPage
      // TanStack keeps the component across a param change: keyed, another
      // genre starts from the first batch of covers, not the last one's.
      key={genreId}
      kind="genre"
      title={genre?.displayName}
      shows={genre ? filterByCategory(shows, genre.id) : []}
      loading={loading}
      error={error}
    />
  );
}
